import React, {useState} from "react";
import {hasAccessory, hasBM} from "../../../bidib/bidib_commons";
import {connect} from "react-redux";

const DomainProp = ({propertyname, value, domain, item, default_, onChange, width, array, arrayindex, bidibitems}) => {

    const _item = item || {}
    const _bidib_items = bidibitems || []

    const [v, setv] = useState(value || default_);
    domain = domain ? domain : []

    let val_missing = false
    if( domain.length !== 0 && !domain.includes(value)) {
        domain.push(value)
        val_missing = true
    }

    //console.log(item)

    function handleChange(e) {
        let tmp = e
        setv(tmp)
        onChange(propertyname, tmp, array, arrayindex)
    }



    return (
        <select
            style={{
                //width: (width || 200) + 'px',
                border: '1px solid #222222',
                marginLeft: '4px',
                height: '19px',
                color: '#C5B477',
                background: '#777777', //val_missing?'#991111':'#999999'
            }}
            value={v} name={propertyname} onChange={(event) => handleChange(event.target.value)}
        >
            {
                <option key={'key_option_empty'} value={''}>{' - - - '}</option>
            }
            {
                <option key={'key_option_na'} value={'NA'}>{'NA'}</option>
            }
            {
                domain.map((itmx,i) => {
                    const bitem = _bidib_items.find(it => it.uid.includes(itmx)) || {}
                    return <option key={'key_xx_'+i} value={itmx}>{bitem.user || itmx}</option>
                })
            }
        </select>
    )
}

function mapStateToProps(state, other) {
    return {bidibitems: state.bidib.data.node || []}
}

export default connect(mapStateToProps)(DomainProp)